const styles = theme => {
  return {
    root: {
      display: 'flex',
      alignItems: 'baseline'
    },
    accountNo: { fontSize: '10px', marginLeft: '5px', color: 'grey' }
  };
};

export default styles;
